export class ChatPermission {
  access = 541;
}